var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVimeo = function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#1eb8eb",
    rx: "50%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M418 185c-19 109-128 202-161 223-32 21-62-9-73-30-12-26-49-164-59-176-9-12-39 12-39 12l-13-19s59-71 104-79c47-10 47 73 59 118 11 45 18 70 27 70 10 0 29-24 49-63 21-37-1-71-41-47 17-95 166-118 147-9z"
  })));
};
export default SvgVimeo;